import { Fragment } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { configurationTableSx } from "./asset-configuration-section";
import { Asset } from "~/pages/inventory/asset/types";
import { CopyText } from "./CopyText";
import { extractAssetKey, extractAssetValue } from "~/lib/assetUtils";

type AssetPlatformOverviewProps = {
  asset: Asset;
};

export function AssetPlatformOverview({ asset }: AssetPlatformOverviewProps) {
  const platformGroup = asset.overviewGroups.find(
    (g) => g.title === "Platform overview",
  );

  const noResults = !platformGroup && (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        px: 2,
        pt: 2,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        No Data
      </Typography>
    </Box>
  );

  const results = platformGroup && (
    <TableContainer>
      <Table
        sx={{ tableLayout: "fixed", "& tr:hover": { background: "inherit" } }}
      >
        <TableHead sx={{ backgroundColor: "inherit", boxShadow: "none" }}>
          <TableRow
            sx={{
              "&:hover": {
                pointerEvents: "none",
                background: "inherit",
              },
            }}
          >
            <TableCell
              colSpan={2}
              sx={{
                pl: 0,
                pb: 1,
                borderBottom: (theme) =>
                  `1px solid ${theme.palette.background.lightest}`,
                textTransform: "uppercase",
              }}
            >
              <Typography component="h3" variant="body2" fontWeight={500}>
                {platformGroup.title}
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={configurationTableSx}>
          {platformGroup.items.map((item) => {
            const key = extractAssetKey(item);
            const value = extractAssetValue(item);
            return (
              <Fragment key={item.key}>
                <TableRow>
                  <TableCell className={"key width-50"} sx={{ pl: 0 }}>
                    {key}
                  </TableCell>
                  <TableCell className={"width-50"} sx={{ pl: 0 }}>
                    <CopyText>{value}</CopyText>
                  </TableCell>
                </TableRow>
              </Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return <Box>{results || noResults}</Box>;
}
